import { EventBus } from '@/components/eventbus/EventBus'
import { POPUP_STANDARD } from '@/common/resources/const'

export const voucherModalManager = () => {
  const closeLayerPopup = () => {
    EventBus.$emit(POPUP_STANDARD, { isOpen: false })
  }

  const openModal = {
    promotion: (args = {}) => {
      EventBus.$emit(POPUP_STANDARD, { isOpen: true, ...args })
    },
  }

  /**
   * eventName 을 받아 handler 가 있을 경우 handler 로직 처리 후 결과 값을 resolve,
   * modal 에서 confirm 이후 처리되는 비동기 로직,
   * resolve(true) | resolve(false) 를 반환,
   * (return 전 로직이 필요 할 경우 handler callback 함수 에서 처리 후 true | false 리턴)
   * @param eventName
   * @param handler
   * @returns {Promise<unknown> | Promise}
   */
  const waitForEvent = (eventName, handler = (v) => v) => {
    return new Promise((resolve) => {
      EventBus.$once(eventName, (payload) => {
        const result = handler ? handler(payload) : payload

        resolve(result)
      })
    })
  }

  return {
    openModal,
    closeLayerPopup,
    waitForEvent,
  }
}
